import {Response, ResponseArray} from 'setup/axios/HttpResponse'
import {serviceManagementAction} from './ServiceManagementSlice'
import {ServiceManagementApi} from './ServiceManagementApi'
import {call, takeEvery, takeLatest, takeLeading} from 'redux-saga/effects'
import {COMMON_ERROR, HTTP_RESPONSE_STATUS} from 'setup/constants/Http'
import {toast} from 'react-toastify'
import {ToastDefaultConfig} from '../../../../setup/toast/ToastConfig'
import {PayloadAction} from '@reduxjs/toolkit'
import {
  CreatePackageForMajorServiceCentroRequestBody,
  GetBusInfoDetailByCompanyRequestBody,
  GetBusInfoDetailByCompanyResponseData,
  GetListPackageByMajorServiceIdRequestBody,
  PackageWorkflowServiceModel,
  ServiceManagementPackageInfoModel,
  UpdatePackageForMajorServiceCentroRequestBody,
  UpdatePackageStatusForMajorServiceCentroRequestBody,
  updateSameDayBookingRequestBody,
  GetAllServiceGroupRequestBody,
  ServiceGroupQry,
  GetServiceGroupDetailRequestBody,
  SubServiceInfoDTO,
  SaveServiceGroupRequestBody,
  createPackageServiceBundleRequestBody,
  CentroCategoryInfoDetailQry,
  UpdateCentroCategoryInfoRequestBody,
  CentroCategoryInfoModel,
  CentroCategoryListRequest,
  ServiceInfoModel,
  GetServiceRequest,
  GetSubServiceRequest,
  GetSubSubServiceRequest,
  UpdateCentroCategoryStatusRequestBody,
  CentroServiceConfigQry,
  GetCentroServiceConfigRequest,
  SaveCentroServiceConfigRequestBody,
  AddCentroCategoryServiceRequestBody,
  UpdateCentroCategoryServiceRequestBody,
  CentroCategoryServiceQry,
} from '../models'
import {CataloguePayload} from '../components/catalogue-modal/catalogueModel'

function* getListPackageWorkflowService(
  action: PayloadAction<{callback: (res: PackageWorkflowServiceModel[] | null, err: any) => void}>
) {
  const {callback} = action.payload
  try {
    const response: ResponseArray<PackageWorkflowServiceModel> = yield call(
      ServiceManagementApi.getListPackageWorkflowService
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data, null)
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* createPackageWorkflowService(
  action: PayloadAction<{callback: (res: boolean | null, err: any) => void; body: FormData}>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.createPackageWorkflowService,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updatePackageWorkflowService(
  action: PayloadAction<{callback: (res: boolean | null, err: any) => void; body: FormData}>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updatePackageWorkflowService,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updateSameDayBooking(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: updateSameDayBookingRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(ServiceManagementApi.updateSameDayBooking, body)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getBusInfoDetailByCompany(
  action: PayloadAction<{
    callback: (res: GetBusInfoDetailByCompanyResponseData | null, err: any) => void
    body: GetBusInfoDetailByCompanyRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<GetBusInfoDetailByCompanyResponseData> = yield call(
      ServiceManagementApi.getBusInfoDetailByCompany,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getListPackageByMajorServiceId(
  action: PayloadAction<{
    callback: (res: ServiceManagementPackageInfoModel[] | null, err: any) => void
    body: GetListPackageByMajorServiceIdRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<ServiceManagementPackageInfoModel[]> = yield call(
      ServiceManagementApi.getListPackageByMajorServiceId,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* createPackageForMajorServiceCentro(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: CreatePackageForMajorServiceCentroRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.createPackageForMajorServiceCentro,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updatePackageForMajorServiceCentro(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: UpdatePackageForMajorServiceCentroRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updatePackageForMajorServiceCentro,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updatePackageStatusForMajorServiceCentro(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: UpdatePackageStatusForMajorServiceCentroRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updatePackageStatusForMajorServiceCentro,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getAllServiceGroup(
  action: PayloadAction<{
    callback: (res: ServiceGroupQry[] | null, err: any) => void
    serviceId: number
  }>
) {
  const {callback, serviceId} = action.payload
  try {
    const response: Response<ServiceGroupQry[]> = yield call(
      ServiceManagementApi.getAllServiceGroup,
      serviceId
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getServiceGroupDetail(
  action: PayloadAction<{
    callback: (res: ServiceGroupQry | null, err: any) => void
    body: GetServiceGroupDetailRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<ServiceGroupQry> = yield call(
      ServiceManagementApi.getServiceGroupDetail,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getServiceGroupList(
  action: PayloadAction<{
    callback: (res: ServiceGroupQry[] | null, err: any) => void
    body: {serviceId: number}
  }>
) {
  const {callback, body} = action.payload
  try {
    // Use the same API but expect array response when no id is provided
    const response: Response<ServiceGroupQry[]> = yield call(
      ServiceManagementApi.getServiceGroupDetail,
      {serviceId: body.serviceId}
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getSubServiceInfo(
  action: PayloadAction<{
    callback: (res: SubServiceInfoDTO[] | null, err: any) => void
    serviceId: number
  }>
) {
  const {callback, serviceId} = action.payload
  try {
    const response: Response<SubServiceInfoDTO[]> = yield call(
      ServiceManagementApi.getSubServiceInfo,
      serviceId
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* saveServiceGroup(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: SaveServiceGroupRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(ServiceManagementApi.saveServiceGroup, body)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
      if (response.data) {
        toast.success('Service group saved successfully!', ToastDefaultConfig())
      }
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
    toast.error('Failed to save service group', ToastDefaultConfig())
  }
}

function* saveAllServiceGroups(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: SaveServiceGroupRequestBody[]
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(ServiceManagementApi.saveAllServiceGroups, body)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
      // if (response.data) {
      //   toast.success("All service groups saved successfully!", ToastDefaultConfig());
      // }
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      // toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig());
    }
  } catch (error: any) {
    callback(null, error)
    // toast.error("Failed to save service groups", ToastDefaultConfig());
  }
}

function* deleteServiceGroup(
  action: PayloadAction<{callback: (res: boolean | null, err: any) => void; id: number}>
) {
  const {callback, id} = action.payload
  try {
    const response: Response<boolean> = yield call(ServiceManagementApi.deleteServiceGroup, id)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
      // if (response.data) {
      //   toast.success("Service group deleted successfully!", ToastDefaultConfig());
      // }
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      // toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig());
    }
  } catch (error: any) {
    callback(null, error)
    // toast.error("Failed to delete service group", ToastDefaultConfig());
  }
}

function* getPackageServiceInfo(
  action: PayloadAction<{callback: (res: any | null, err: any) => void; data: any}>
) {
  const {callback} = action.payload
  try {
    const response: Response<any> = yield call(
      ServiceManagementApi.getPackageServiceInfo,
      action.payload.data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getBundleDataFromPackage(
  action: PayloadAction<{callback: (res: any | null, err: any) => void; data: any}>
) {
  const {callback} = action.payload
  try {
    const response: Response<any> = yield call(
      ServiceManagementApi.getBundleDataFromPackage,
      action.payload.data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* createPackageServiceBundle(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: createPackageServiceBundleRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.createPackageServiceBundle,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getPackageServiceBundle(
  action: PayloadAction<{callback: (res: any | null, err: any) => void; data: any}>
) {
  const {callback} = action.payload
  try {
    const response: Response<any> = yield call(
      ServiceManagementApi.getPackageServiceBundle,
      action.payload.data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updatePackageServiceBundle(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: createPackageServiceBundleRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updatePackageServiceBundle,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

// Surfaces the backend validation message (if any) so the caller can show it inline
const toErrorMessage = (error: unknown): string =>
  (error as {response?: {data?: {message?: string}}})?.response?.data?.message ||
  COMMON_ERROR.pleaseTryAgain

function* getCentroCategoryInfoDetail(
  action: PayloadAction<{
    callback: (res: CentroCategoryInfoDetailQry | null, err: any) => void
    id: string
  }>
) {
  const {callback, id} = action.payload
  try {
    const response: Response<CentroCategoryInfoDetailQry> = yield call(
      ServiceManagementApi.getCentroCategoryInfoDetail,
      id
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error) {
    callback(null, toErrorMessage(error))
  }
}

function* addCentroCategoryInfo(
  action: PayloadAction<{callback: (res: boolean | null, err: any) => void; body: FormData}>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(ServiceManagementApi.addCentroCategoryInfo, body)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error) {
    callback(null, toErrorMessage(error))
  }
}

function* updateCentroCategoryInfo(
  action: PayloadAction<{
    callback: (res: boolean | null, err: any) => void
    body: UpdateCentroCategoryInfoRequestBody
  }>
) {
  const {callback, body} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updateCentroCategoryInfo,
      body
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error) {
    callback(null, toErrorMessage(error))
  }
}

function* getCategoryList(
  action: PayloadAction<{
    callback: (res: CentroCategoryInfoModel[] | null, err: any) => void
    data: CentroCategoryListRequest
  }>
) {
  const {callback, data} = action.payload

  try {
    const response: Response<CentroCategoryInfoModel[]> = yield call(
      ServiceManagementApi.getCategoryList,
      data
    )

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

type ServiceRequestAction = PayloadAction<{
  data: GetServiceRequest
  callback: (res: CentroCategoryServiceQry[] | null, err: any) => void
}>

function* getServiceByCategoryId(action: ServiceRequestAction) {
  const {data, callback} = action.payload

  try {
    const response: Response<CentroCategoryServiceQry[]> = yield call(
      ServiceManagementApi.getServiceByCategoryId,
      data
    )

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)
      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

type GetSubServiceAction = PayloadAction<{
  data: GetSubServiceRequest
  callback: (res: ServiceInfoModel[] | null, err: any) => void
}>

function* getSubServiceByServiceId(action: GetSubServiceAction) {
  const {data, callback} = action.payload

  try {
    const response: Response<ServiceInfoModel[]> = yield call(
      ServiceManagementApi.getSubServiceByServiceId,
      data
    )

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)

      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

type GetSubSubServiceAction = PayloadAction<{
  data: GetSubSubServiceRequest
  callback: (res: ServiceInfoModel[] | null, err: any) => void
}>

function* getSubSubServiceBySubServiceId(action: GetSubSubServiceAction) {
  const {data, callback} = action.payload

  try {
    const response: Response<ServiceInfoModel[]> = yield call(
      ServiceManagementApi.getSubSubServiceBySubServiceId,
      data
    )

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, COMMON_ERROR.pleaseTryAgain)

      toast.error(COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

type UpdateCentroCategoryStatusAction = PayloadAction<{
  data: UpdateCentroCategoryStatusRequestBody
  callback: (res: boolean | null, err: any) => void
}>

type UpdateCentroCategoryServiceStatusAction = PayloadAction<{
  data: UpdateCentroCategoryInfoRequestBody
  callback: (res: boolean | null, err: any) => void
}>

function* updateCentroCategoryStatus(action: UpdateCentroCategoryStatusAction) {
  const {data, callback} = action.payload

  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updateCentroCategoryStatus,
      data
    )

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data ?? null,
        response.data !== undefined ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)

      toast.error(response?.message || COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updateCentroCategoryServiceStatus(action: UpdateCentroCategoryServiceStatusAction) {
  const {data, callback} = action.payload

  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updateCentroCategoryServiceStatus,
      data
    )

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data ?? null,
        response.data !== undefined ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)

      toast.error(response?.message || COMMON_ERROR.pleaseTryAgain, ToastDefaultConfig())
    }
  } catch (error: any) {
    callback(null, error)
  }
}

// CNT-10 - per-company service configuration
function* getCentroServiceConfig(
  action: PayloadAction<{
    data: GetCentroServiceConfigRequest
    callback: (res: CentroServiceConfigQry | null, err: any) => void
  }>
) {
  const {callback, data} = action.payload
  try {
    const response: Response<CentroServiceConfigQry | null> = yield call(
      ServiceManagementApi.getCentroServiceConfig,
      data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      // data is null when the node has no configuration yet - a valid result, not an error
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* saveCentroServiceConfig(
  action: PayloadAction<{
    data: SaveCentroServiceConfigRequestBody
    callback: (res: boolean | null, err: any) => void
  }>
) {
  const {callback, data} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.saveCentroServiceConfig,
      data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

// CNT-10 - custom service nodes
function* addCentroCategoryService(
  action: PayloadAction<{
    data: AddCentroCategoryServiceRequestBody
    callback: (res: string | null, err: any) => void
  }>
) {
  const {callback, data} = action.payload
  try {
    const response: Response<string | null> = yield call(
      ServiceManagementApi.addCentroCategoryService,
      data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* updateCentroCategoryService(
  action: PayloadAction<{
    data: UpdateCentroCategoryServiceRequestBody
    callback: (res: boolean | null, err: any) => void
  }>
) {
  const {callback, data} = action.payload
  try {
    const response: Response<boolean> = yield call(
      ServiceManagementApi.updateCentroCategoryService,
      data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(
        response.data || null,
        response.data ? null : response?.message || COMMON_ERROR.pleaseTryAgain
      )
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* uploadCentroCategoryServiceIcon(
  action: PayloadAction<{data: FormData; callback: (res: string | null, err: any) => void}>
) {
  const {callback, data} = action.payload
  try {
    const response: Response<string | null> = yield call(
      ServiceManagementApi.uploadCentroCategoryServiceIcon,
      data
    )
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}
function* setServiceDefault(action: PayloadAction<{ callback: (res: string | null, err: any) => void }>) {
  const { callback } = action.payload;
  try {
    const response: Response<string | null> = yield call(ServiceManagementApi.setServiceDefault);
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

// CNT-147 - get b8ak catalogue and category list for service tree
function* getb8akCatalogue(
  action: PayloadAction<{callback: (res: string | null, err: any) => void}>
) {
  const {callback} = action.payload
  try {
    const response: Response<string | null> = yield call(ServiceManagementApi.getb8akCatalogue)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* getB8AKCategoryList(
  action: PayloadAction<{callback: (res: string | null, err: any) => void}>
) {
  const {callback} = action.payload
  try {
    const response: Response<string | null> = yield call(ServiceManagementApi.getB8AKCategoryList)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

function* addCategory(
  action: PayloadAction<{data: CataloguePayload; callback: (res: string | null, err: any) => void}>
) {
  const {data, callback} = action.payload
  try {
    const response: Response<string | null> = yield call(ServiceManagementApi.addCategory, data)
    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
      callback(response.data ?? null, null)
    } else {
      callback(null, response?.message || COMMON_ERROR.pleaseTryAgain)
    }
  } catch (error: any) {
    callback(null, error)
  }
}

export default function* serviceManagementSaga() {
  yield takeLatest(
    serviceManagementAction.getListPackageWorkflowService,
    getListPackageWorkflowService
  )
  yield takeLatest(
    serviceManagementAction.createPackageWorkflowService,
    createPackageWorkflowService
  )
  yield takeLatest(
    serviceManagementAction.updatePackageWorkflowService,
    updatePackageWorkflowService
  )
  yield takeLatest(serviceManagementAction.updateSameDayBooking, updateSameDayBooking)
  yield takeLatest(serviceManagementAction.getBusInfoDetailByCompany, getBusInfoDetailByCompany)
  yield takeLatest(
    serviceManagementAction.getListPackageByMajorServiceId,
    getListPackageByMajorServiceId
  )
  yield takeLatest(
    serviceManagementAction.createPackageForMajorServiceCentro,
    createPackageForMajorServiceCentro
  )
  yield takeLatest(
    serviceManagementAction.updatePackageForMajorServiceCentro,
    updatePackageForMajorServiceCentro
  )
  yield takeLatest(
    serviceManagementAction.updatePackageStatusForMajorServiceCentro,
    updatePackageStatusForMajorServiceCentro
  )
  yield takeLatest(serviceManagementAction.getAllServiceGroup, getAllServiceGroup)
  yield takeLatest(serviceManagementAction.getServiceGroupDetail, getServiceGroupDetail)
  yield takeLatest(serviceManagementAction.getServiceGroupList, getServiceGroupList)
  yield takeLatest(serviceManagementAction.getSubServiceInfo, getSubServiceInfo)
  yield takeLatest(serviceManagementAction.saveServiceGroup, saveServiceGroup)
  yield takeLatest(serviceManagementAction.saveAllServiceGroups, saveAllServiceGroups)
  yield takeLatest(serviceManagementAction.deleteServiceGroup, deleteServiceGroup)
  yield takeLatest(serviceManagementAction.getPackageServiceInfo, getPackageServiceInfo)
  yield takeLatest(serviceManagementAction.getBundleDataFromPackage, getBundleDataFromPackage)
  yield takeLatest(serviceManagementAction.createPackageServiceBundle, createPackageServiceBundle)
  yield takeLatest(serviceManagementAction.getPackageServiceBundle, getPackageServiceBundle)
  yield takeLatest(serviceManagementAction.updatePackageServiceBundle, updatePackageServiceBundle)
  yield takeLatest(serviceManagementAction.getCentroCategoryInfoDetail, getCentroCategoryInfoDetail)
  yield takeLeading(serviceManagementAction.addCentroCategoryInfo, addCentroCategoryInfo)
  yield takeLeading(serviceManagementAction.updateCentroCategoryInfo, updateCentroCategoryInfo)
  yield takeLatest(serviceManagementAction.getCategoryList.type, getCategoryList)
  // Separate action so the Major modal's dropdown fetch never cancels the tree's
  // getCategoryList and leaves the tree spinning
  yield takeLatest(serviceManagementAction.getCategoryOptions.type, getCategoryList)
  // takeEvery, not takeLatest: the service tree loads sibling branches in parallel, and
  // each request carries its own callback that clears that row's spinner. takeLatest
  // cancels the earlier branch, so its callback never runs and its row spins forever.
  yield takeEvery(serviceManagementAction.getServiceByCategoryId.type, getServiceByCategoryId)
  yield takeEvery(serviceManagementAction.getSubServiceByServiceId.type, getSubServiceByServiceId)
  yield takeEvery(
    serviceManagementAction.getSubSubServiceBySubServiceId.type,
    getSubSubServiceBySubServiceId
  )
  yield takeEvery(
    serviceManagementAction.updateCentroCategoryStatus.type,
    updateCentroCategoryStatus
  )
  yield takeEvery(
    serviceManagementAction.updateCentroCategoryServiceStatus.type,
    updateCentroCategoryServiceStatus
  )
  yield takeLatest(serviceManagementAction.getCentroServiceConfig.type, getCentroServiceConfig)
  yield takeLatest(serviceManagementAction.saveCentroServiceConfig.type, saveCentroServiceConfig)
  yield takeLatest(serviceManagementAction.addCentroCategoryService.type, addCentroCategoryService)
  yield takeLatest(
    serviceManagementAction.updateCentroCategoryService.type,
    updateCentroCategoryService
  )
  yield takeLatest(
    serviceManagementAction.uploadCentroCategoryServiceIcon.type,
    uploadCentroCategoryServiceIcon
  )
  yield takeLatest(serviceManagementAction.setServiceDefault.type, setServiceDefault);
  yield takeLatest(serviceManagementAction.getB8akCatalogue.type, getb8akCatalogue)
  yield takeLatest(serviceManagementAction.getB8AKCategoryList.type, getB8AKCategoryList)
  yield takeLatest(serviceManagementAction.addCategory.type, addCategory)
}
